<div class="h-full w-full bg-white">
  <twaice-fe-empty-solution [illustration]="illustration" headline="Feature not available" [demos]="false">
    <p nz-typography class="text-sm mb-16">
      The data required for this feature is not available for your system. As a result, insights for this feature cannot be
      generated.
    </p>
    <p nz-typography class="text-sm">If you have any questions, contact TWAICE support through the platform chat.</p>
  </twaice-fe-empty-solution>
</div>
